import ContractInfoApp from './ContractInfoApp.vue'
import ContractMap from './pages/ContractMap.vue'
import SiteOutline from './pages/SiteOutline.vue'
import SiteOutlineEdit from './pages/SiteOutlineEdit.vue'
import SiteOutlinePhotoEdit from './pages/SiteOutlinePhotoEdit.vue'
import SiteOutlinePhotoPDF from './pages/SiteOutlinePhotoPDF.vue'

export default {
  path: '/ContractInfo',
  component: ContractInfoApp,
  children: [
    {
      path: '/ContractMap',
      name: 'ContractMap',
      component: ContractMap,
      meta: { requiresAuth: true, title: 'apollo-RP - MAP' },
      props: true
    },
    {
      path: '/SiteOutline',
      name: 'SiteOutline',
      component: SiteOutline,
      meta: { requiresAuth: true, title: 'apollo-RP - 物件概要書' },
      props: true
    },
    {
      path: '/SiteOutlineEdit',
      name: 'SiteOutlineEdit',
      component: SiteOutlineEdit,
      meta: { requiresAuth: true, title: '物件概要書編集' },
      props: true
    },
    {
      path: '/SiteOutlinePhotoEdit',
      name: 'SiteOutlinePhotoEdit',
      component: SiteOutlinePhotoEdit,
      meta: { requiresAuth: true, title: '詳細写真編集' },
      props: true
    },
    {
      path: '/SiteOutlinePhotoPDF',
      name: 'SiteOutlinePhotoPDF',
      component: SiteOutlinePhotoPDF,
      meta: { isPublic: true, title: '詳細写真PDF' },
      props: true
    }
  ]
}
